import { DefaultPageState } from "../../../common/models/StoreDefaultModel";

export type StorageItemData = {};

export const initialStoragePageState: DefaultPageState = {
  page: 1,
  itemsPerPage: 10,
  pagination: true,
  // order: { dataKey: "id", order: "desc" },
};
